<template>
  <b-form @submit.prevent="onSaveChangeUpdate">
    <div class="position-relative">
      <div class="modal-wrp mx-1">
        <b-row>
          <b-col cols="12" class="px-2">
            <div class="d-flex">
              <div class="mr-auto mt-auto">
                <div class="text-black font-large-1">
                  กำหนดวิธีการแลกของรางวัล
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="" v-if="tableData.payload.length > 0">
          <b-col cols="12">
            <overlay-loading :loading="loading.tableData">
              <template #content>
                <b-table
                  id="inventory-table"
                  :fields="fields"
                  :items="tableData.payload"
                  responsive
                  bordered
                  borderless
                  sticky-header
                  :show-empty="false"
                  class="add-privilege-info-table"
                  thead-class="d-none"
                  thead-tr-class="inventory-th-class text-left"
                >
                  <template #cell(privilegeBadge)="data">
                    <div class="privilege-wrp h-100">
                      <div class="privilege-img overflow-hidden">
                        <img
                          :src="data.item.pv_image_url || DefaultImg"
                          class="h-100 w-100 obj-fit-contain"
                        />
                      </div>
                      <div class="privilege-text-wrp">
                        <div class="d-flex">
                          <div class="mr-auto">
                            <div class="d-flex align-items-center">
                              <feather-icon
                                icon="CircleIcon"
                                class="mr-2"
                                :class="resolveStatusClass(data.item.status)"
                              />

                              <span>{{
                                resolveStatusLabel(data.item.status)
                              }}</span>
                            </div>
                          </div>
                          <div class="ml-auto">
                            <div class="cursor-pointer">
                              <b-button
                                v-b-tooltip.hover
                                title="Edit"
                                class="btn-custom"
                                @click="openEditModal(data.item)"
                              >
                                <edit-icon
                                  class="default-btn-action-svg iconEdit-btn"
                                />
                              </b-button>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex privilege-text-content">
                          <div class="text-black font-medium-2 text-bold">
                            {{ data.item.pv_name_th }}
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="mt-2 flashdeal-text">
                            <div class="font-medium-2 flashdeal-text-privilege-type">{{PRIVILEGE_TYPE.getTypeDesc(data.item.pv_type)}}</div>
                            <div class="font-medium-2">
                              {{
                                resolveDateWithSeperator(
                                  data.item.pv_valid_from
                                )
                              }}
                              ถึง
                              {{
                                resolveDateWithSeperator(
                                  data.item.pv_valid_through
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div
                            class="w-40 point-wrp point-wrp-bg font-medium-2"
                          >
                            <div class="d-flex">
                              <div class="mr-auto mt-auto mb-auto font-medium-5">
                                {{ data.item.pv_point_ref }}
                              </div>
                              <div class="ml-auto mt-auto mb-auto">
                                Point
                              </div>
                            </div>
                          </div>
                          <div class="w-20 text-center m-auto">
                            <arrow-right-icon class="arrow-icon-size" />
                          </div>
                          <div class="w-40 point-wrp font-medium-2">
                            <div class="d-flex">
                              <div class="m-auto pr-10px text-black">
                                <b-form-input
                                  v-model="data.item.criteria_point"
                                  type="number"
                                  placeholder="ระบุ"
                                  class="custom-input border-0 p-0 h-auto"
                                />
                              </div>
                              <div class="m-auto text-black">
                                Point
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-table>
              </template>
            </overlay-loading>
          </b-col>
          <b-col
            cols="12"
            class="d-flex justify-content-end px-2 font-medium-5"
          >
            {{ paginationInfo }}
          </b-col>
        </b-row>
        <empty-content
          v-else
          :image="require('@/assets/images/artwork/folder.png')"
          :width-img="'300px'"
          :height-img="'auto'"
          :title="'Not found select privilege in this inventory'"
          class="empty-content-history-custom-height"
        />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-2"
                :btn-label="'Cancel'"
                @click.native="$emit('onBack')"
              />
              <b-button
                variant="danger"
                class="mr-2"
                @click="onBackPage"
                v-if="pagination.currentPage > 1"
                >Back</b-button
              >
              <save-button
                type="submit"
                :btnLabel="resolveSaveBtnAction.text"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-add-privilege-info
      :privilegeObj="privilegeEditSelect"
      v-if="modalType.editModal"
      @onCloseEditModal="closeEditModal"
      @editPrivilege="editUpdatePrivilege"
    />
  </b-form>
</template>

<script>
import vSelect from "vue-select";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import ArrowRightIcon from "@/@core/components/svg/common/ArrowRight.vue";
import useAddPrivilegeInfo from "../hooks/useAddPrivilegeInfo";
import useDate from "@/utils/hooks/useDate";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import EditAddPrivilegeInfo from "../modal/EditAddPrivilegeInfo.vue";
import EmptyContent from "@/views/components/empty-content/EmptyContent.vue";

export default {
  components: {
    vSelect,
    CardNoItem,
    EditIcon,
    DeleteIcon,
    ArrowRightIcon,
    EditAddPrivilegeInfo,
    EmptyContent,
  },
  props: { privilegeObj: [Object, Array] },
  setup(props) {
    const {
      tableData,
      loading,
      pagination,
      paginationInfo,
      formStatus,
      fields,
      modalType,
      resolveSaveBtnAction,
      privilegeEditSelect,
      PRIVILEGE_TYPE,
      openEditModal,
      closeEditModal,
      onSaveChangeUpdate,
      onBackPage,
      resolveStatusLabel,
      resolveStatusClass,
      editUpdatePrivilege
    } = useAddPrivilegeInfo(props);

    

    const { resolveDateWithSeperator } = useDate();

    return {
      tableData,
      loading,
      pagination,
      paginationInfo,
      formStatus,
      fields,
      modalType,
      DefaultImg,
      resolveSaveBtnAction,
      PRIVILEGE_TYPE,
      privilegeEditSelect,
      resolveDateWithSeperator,
      openEditModal,
      closeEditModal,
      onSaveChangeUpdate,
      onBackPage,
      resolveStatusLabel,
      resolveStatusClass,
      editUpdatePrivilege,
      editUpdatePrivilege
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/status.css";
</style>
